import React from 'react'

import { Pagination } from 'react-admin'

const JobPagination = ({ options = [10, 25, 50, 100, 200], ...rest }) => (
  <Pagination rowsPerPageOptions={options} {...rest} />
)

export default JobPagination
